// Trang con của rail chưa có nội dung (Sự Vụ, Hòm Thư): khung rỗng.
import type { JSX } from 'preact';
import { t } from '@i18n/t';

export function EmptyPage(): JSX.Element {
  return <p class="ht-block">{t('ui.page.empty')}</p>;
}
